var jQuery=require("jquery")
window.jQuery=jQuery

window.jQuery(document).ready(function () {
    // Skip analytics in development mode to prevent CORS errors
    if (process.env.NODE_ENV === 'development') {
        console.log('Analytics services disabled in development mode to prevent CORS errors')
        
        // Still load TSS and Service Worker as they're needed for functionality
      /* tss settings starts */
        window.TSS_CONFIG = {
            hosts: [{
                current: "https://img.thesouledstore.com",
                tss: "https://prod-img.thesouledstore.com"
            }],
            lazy_load: false,
            auto_quality: false,
            auto_webp: false,
            width_from_img: true
        };
        (function(){d=document;s=d.createElement("script");s.src="/static/js/main.global.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();
        /* tss settings ends */

        /* sw js starts */
        if ('serviceWorker' in navigator) {
            window.addEventListener('load', function () {
              navigator.serviceWorker.register('/sw.js', {scope: '/'}).then(function (registration) {
                // Registration was successful
                console.log('ServiceWorker registration successful with scope: ', registration.scope)
              }, function (err) {
                // registration failed :(
                console.log('ServiceWorker registration failed: ', err)
              })
            })
        }
        /* sw js ends */
        
        return; // Exit early in development
    }

    /* linkedin js Starts */
    _linkedin_partner_id = "3332458";
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    (function(l) {
    if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
    window.lintrk.q=[]}
    var s = document.getElementsByTagName("script")[0];
    var b = document.createElement("script");
    b.type = "text/javascript";b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    s.parentNode.insertBefore(b, s);})(window.lintrk);
    /* linkedin js Ends */

    /* facebook events setting starts */
    setTimeout(function () {
    window.fbAsyncInit = function () {
        FB.init({
            appId: process.env.FB_APP_ID || 'no-fb-id',
            cookie: true, // enable cookies to allow the server to access the session
            xfbml: true, // parse social plugins on this page
            version: 'v3.2' // graph api version
        });
        // FB.AppEvents.logPageView();
    };
    (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { return; }
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
    /* facebook settings ends */
    /* pixel perfect code start */
      /** DO NOT MODIFY THIS CODE**/
      !function(_window, _document) {
        var OB_ADV_ID='000c7d78f7d5789d55041c8861e3a2cd90';
        if (_window.obApi) {var toArray = function(object) {return Object.prototype.toString.call(object) === '[object Array]' ? object : [object];};_window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(toArray(OB_ADV_ID));return;}
        var api = _window.obApi = function() {api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments);};api.version = '1.1';api.loaded = true;api.marketerId = OB_ADV_ID;api.queue = [];var tag = _document.createElement('script');tag.async = true;tag.src = '//amplify.outbrain.com/cp/obtp.js';tag.type = 'text/javascript';var script = _document.getElementsByTagName('script')[0];script.parentNode.insertBefore(tag, script);}(window, document);
      obApi('track', 'PAGE_VIEW');
    /* <!-- pixel perfect code ends --> */
    }, 6000);  
    
    /* tss settings starts */
    window.TSS_CONFIG = {
        hosts: [{
            current: "https://img.thesouledstore.com",
            tss: "https://prod-img.thesouledstore.com"
        }],
        lazy_load: false,
        auto_quality: false,
        auto_webp: false,
        width_from_img: true
    };
    (function(){d=document;s=d.createElement("script");s.src="/static/js/main.global.js";s.async=1;d.getElementsByTagName("head")[0].appendChild(s);})();
    /* tss settings ends */

    /* sw js starts */
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', function () {
          navigator.serviceWorker.register('/sw.js', {scope: '/'}).then(function (registration) {
            // Registration was successful
            console.log('ServiceWorker registration successful with scope: ', registration.scope)
          }, function (err) {
            // registration failed :(
            console.log('ServiceWorker registration failed: ', err)
          })
        })
    }
    /* sw js ends */

    
})


//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = 1013
// module chunks = 113